import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

/**
 * Fullscreen-off icon
 *
 * @file FullscreenOff.jsx
 * @author Sam George
 */
const FullscreenOff = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <path
      fill="currentcolor"
      d="M22,14 C22.5522847,14 23,14.4477153 23,15 C23,15.5522847
      22.5522847,16 22,16 L17,16 C16.4477153,16 16,16.4477153 16,17
      L16,22 C16,22.5522847 15.5522847,23 15,23 C14.4477153,23 14,22.5522847
      14,22 L14,17 C14,15.3431458 15.3431458,14 17,14 L22,14 Z M7,14
      C8.65685425,14 10,15.3431458 10,17 L10,22 C10,22.5522847 9.55228475,23
      9,23 C8.44771525,23 8,22.5522847 8,22 L8,17 C8,16.4477153 7.55228475,16
      7,16 L2,16 C1.44771525,16 1,15.5522847 1,15 C1,14.4477153 1.44771525,14
      2,14 L7,14 Z M15,1 C15.5522847,1 16,1.44771525 16,2 L16,7 C16,7.55228475
      16.4477153,8 17,8 L22,8 C22.5522847,8 23,8.44771525 23,9 C23,9.55228475
      22.5522847,10 22,10 L17,10 C15.3431458,10 14,8.65685425 14,7
      L14,2 C14,1.44771525 14.4477153,1 15,1 Z M9,1 C9.55228475,1
      10,1.44771525 10,2 L10,7 C10,8.65685425 8.65685425,10 7,10
      L2,10 C1.44771525,10 1,9.55228475 1,9 C1,8.44771525 1.44771525,8
      2,8 L7,8 C7.55228475,8 8,7.55228475 8,7 L8,2 C8,1.44771525
      8.44771525,1 9,1 Z"
    />
  </SvgIcon>
);

export default FullscreenOff;
